import React, { useState } from "react";
import { makeStyles, Paper, Backdrop } from "@material-ui/core";
import { ApiService } from "../services";
import { useSnackbar } from "react-simple-snackbar";
import styled from "styled-components";
import GButton from "../gComponents/gButton";
import { ReactComponent as Check } from "../assets/images/tick.svg";
import { ReactComponent as UnCheck } from "../assets/images/untick.svg";
import GText from "../gComponents/gText";

const Div = styled.div`
  margin: 20px 15px;
  .radio {
    padding: 7px 5px;
    input {
      margin: 0 10px;
      vertical-align: middle;
    }
    label {
      svg {
        height: 20px;
        width: 20px;
        margin-right: 10px;
        vertical-align: top;

        &.checked {
          path {
            fill: #FC4F56;
          }
        }
      }
    }
  }
`;
const useStyles = makeStyles((theme) => ({
  root: {
    position: "fixed",
    bottom: "15px",
    right: "15px",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

export default function ReciveOrderPayment(props) {
  const classes = useStyles();
  const [openSnackbar] = useSnackbar();
  const [selectedGateway, setSelectedGateway] = useState("cash");

  const onRecievePayment = () => {
    if (!selectedGateway) {
      openSnackbar("Choose payment method");
      return;
    }
    var values = {
      amount: props.pendingAmount,
      gateway: selectedGateway,
    };
    console.log(values);
    //return;
    ApiService({
      method: "POST",
      route: "order/payment/" + props.linkedId,
      body: values,
    }).then((response) => {
      console.log("r" + response.status_code);
      if (response.data.status_code === 1) {
        props.setTransModalVisible(false);
        props.onSubmit();
      }
      openSnackbar(response.data.message);
      return;
    });
  };

  const handleClose = (e) => {
    if (e.target.id !== (2739).toString()) {
      return;
    }
    props.setTransModalVisible(false);
  };

  if (props.transModalVisible === false) {
    return null;
  }

  return (
    <div
      style={{
        position: "absolute",
        margin: "auto",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      }}
    >
      <Backdrop
        id="2739"
        className={classes.backdrop}
        open={props.transModalVisible}
        onClick={handleClose}
      >
        <Paper
          className={`modalRight
              ${props.transModalVisible === true ? "fadeM" : ""}`}
          style={{ padding: "20px", maxWidth: "500px" }}
        >
          <GText
            g3
            bold
            text={"Receive Pending Payment"}
            style={{ padding: "0 15px" }}
          />

          <Div>
            <GText g4 theme text={"#" + props.linkedId} />
            <GText
              g4
              med
              text={"Pending Amount - " + props.amount}
              style={{ fontStyle: "italic" }}
            />
            <GText
              g4
              semi
              text={"Choose Payment Method"}
              style={{ marginTop: "25px" }}
            />
            <div className="radio">
              <label>
                <input
                  type="radio"
                  value="cash"
                  checked={selectedGateway === "cash"}
                  onChange={() => setSelectedGateway("cash")}
                  style={{ display: "none" }}
                />
                {selectedGateway === "cash" ? (
                  <Check className="checked" />
                ) : (
                  <UnCheck />
                )}
                Cash On Delivery
              </label>
            </div>
            <br />
            <GButton
              variant="condensed"
              children="Received"
              onClick={() => {
                onRecievePayment();
              }}
              style={{
                margin: "10px 5px",
              }}
            ></GButton>
          </Div>
        </Paper>
      </Backdrop>
    </div>
  );
}
